import {
  jb_teaser_block_css_default
} from "./chunk.EYF2DSDT.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.TC6HXM2Y.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  ChangesBackgroundColor
} from "./chunk.XYH4LHGJ.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  o,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-teaser-block/jb-teaser-block.ts
var JbTeaserBlock = class extends Spaceable(ChangesBackgroundColor(i)) {
  constructor() {
    super(...arguments);
    this._shownTeasersCount = 0;
  }
  firstUpdated() {
    const curatedTeasers = this._slottedChildren?.filter((element) => !element.getAttribute("randomized")) ?? [];
    const randomTeasers = this._slottedChildren?.filter((element) => element.getAttribute("randomized")) ?? [];
    const randomizedRandomTeasers = this.shuffle(randomTeasers);
    randomizedRandomTeasers.forEach((teaser, index) => {
      if (index > this.teaserCount - curatedTeasers.length - 1) {
        teaser.style.setProperty("display", "none");
      }
    });
    this._updateShownTeasers();
  }
  shuffle(array) {
    let currentIndex = array.length;
    let randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
    return array;
  }
  _enableAnimation() {
    return !(document.querySelector("jb-info-page-hero")?.parentElement?.nextElementSibling?.querySelector("jb-teaser-block") === this);
  }
  _getContentSpacingProperties() {
    return {
      grid: true,
      colsMdUp: 12,
      type: "teaser-block"
    };
  }
  _tracking(e3) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e3, {
      component_name: "teaser-block"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _updateShownTeasers() {
    const shownTeasers = (this._slottedChildren ?? []).filter(
      (element) => element.style.getPropertyValue("display") !== "none"
    );
    this._shownTeasersCount = shownTeasers.length;
  }
  render() {
    return b`<section>
      ${(this.headline || this.subline) && b`
          <div class="headline">
            ${this.headline && b`<jb-section-headline .headline=${this.headline}></jb-section-headline>`}
            ${this.subline && b`<p class="subline">${this.subline}</p>`}
          </div>
        `}
      <div class="content teaser-slot ${e2({
      four: this._shownTeasersCount === 4,
      campaign: this.parentElement?.nodeName === "JB-CAMPAIGN-PAGE-HERO"
    })}">
        <jb-heading-context offset=${this.headline ? 1 : 0}>
          <slot @slotchange=${this._updateShownTeasers}></slot>
        </jb-heading-context>
      </div>
      <div class="${e2({
      content: true,
      "button-slot": true,
      "has-slotted-buttons": (this._slottedButtons?.length ?? 0) > 0
    })}">
        <slot name="button" @jb-link:clicked=${this._tracking}></slot>
      </div>
    </div>
  </section>`;
  }
};
JbTeaserBlock.styles = [reset_css_default, jb_teaser_block_css_default];
__decorateClass([
  n()
], JbTeaserBlock.prototype, "background", 2);
__decorateClass([
  n({ reflect: true })
], JbTeaserBlock.prototype, "headline", 2);
__decorateClass([
  n()
], JbTeaserBlock.prototype, "subline", 2);
__decorateClass([
  n({ type: Number })
], JbTeaserBlock.prototype, "teaserCount", 2);
__decorateClass([
  e(".row")
], JbTeaserBlock.prototype, "_row", 2);
__decorateClass([
  r()
], JbTeaserBlock.prototype, "_shownTeasersCount", 2);
__decorateClass([
  o({ slot: "button" })
], JbTeaserBlock.prototype, "_slottedButtons", 2);
__decorateClass([
  o()
], JbTeaserBlock.prototype, "_slottedChildren", 2);
JbTeaserBlock = __decorateClass([
  customElement("jb-teaser-block")
], JbTeaserBlock);

export {
  JbTeaserBlock
};
